/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_Indexnow_SubmittedInputs */

const en_admin_indexnow_submitted = /** @type {(inputs: Admin_Indexnow_SubmittedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Submitted ${i?.count} URLs`)
};

/**
* | output |
* | --- |
* | "Submitted {count} URLs" |
*
* @param {Admin_Indexnow_SubmittedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_indexnow_submitted = /** @type {((inputs: Admin_Indexnow_SubmittedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Indexnow_SubmittedInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_indexnow_submitted(inputs)
});
export { admin_indexnow_submitted as "admin.indexnow.submitted" }